import React, { useState } from "react";

// Renders the first `limit` items plus a clickable "+N more" / "Show less" toggle.
export const Expandable = ({ items = [], limit, render, moreLabel, className = "", testid }) => {
    const [open, setOpen] = useState(false);
    const extra = items.length - limit;
    return (
        <>
            {(open ? items : items.slice(0, limit)).map(render)}
            {extra > 0 && (
                <button
                    type="button"
                    onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
                    data-testid={testid}
                    className={`cursor-pointer hover:underline underline-offset-2 ${className}`}
                >
                    {open ? "Show less" : moreLabel ? moreLabel(extra) : `+${extra} more`}
                </button>
            )}
        </>
    );
};
